/**
 * Tracks Cookiebot marketing consent state.
 *
 * Returns:
 * - `marketingConsent` — computed ref, `true` when Cookiebot marketing consent is granted (always `false` on server)
 * - `consentChanged` — counter bumped on every `CookiebotOnAccept` / `CookiebotOnDecline` event
 *
 * Both Pixel and CAPI gating rely on these values.
 */
export const useCookiebot = () => {
  const marketingConsent = computed(() => {
    if (import.meta.server) return false
    return !!(window as any).Cookiebot?.consent?.marketing
  })

  const consentChanged = ref(0)

  onMounted(() => {
    const check = () => {
      if ((window as any).Cookiebot?.consent?.marketing !== undefined) {
        consentChanged.value++
      }
    }
    window.addEventListener('CookiebotOnAccept', check)
    window.addEventListener('CookiebotOnDecline', check)
    onUnmounted(() => {
      window.removeEventListener('CookiebotOnAccept', check)
      window.removeEventListener('CookiebotOnDecline', check)
    })
  })

  return { marketingConsent, consentChanged }
}
